import { render, staticRenderFns } from "./recharge_detail.vue?vue&type=template&id=18962d8d&scoped=true"
import script from "./recharge_detail.vue?vue&type=script&lang=js"
export * from "./recharge_detail.vue?vue&type=script&lang=js"
import style0 from "./recharge_detail.vue?vue&type=style&index=0&id=18962d8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18962d8d",
  null
  
)

export default component.exports